import { API } from '@/api'

export const fetchSuggestionInProjects = (str) => API.get(`/projects/suggestions_search/?value=${str}`);
export const fetchSuggestionInProject = (projectId, str) => API.get(`/projects/${projectId}/suggestions_search/?value=${str}`);

export const createProject = data => API.post('/projects/', data);
export const getProjects = (query = {}, sorting = 'desc') => {
  console.log(query)
  const q = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');
  return API.get(`/projects/?order=${sorting === 'desc' ? '-' : ''}updated_at&${q}`)
}

export const getModelInfo = projectId => API.get(`/projects/${projectId}/model_info/`);
export const getProjectLogs = () => API.get('/projects/logs/');

export const deleteProject = (projectId) => API.delete(`/projects/${projectId}/`);
export const rerunProject = (projectId, params) => API.get(`/projects/${projectId}/rerun/`, { params });
export const duplicateProject = (projectId) => API.get(`/projects/${projectId}/rerun/?duplicate=true`);
export const cancelProjectProcessing = (data) => API.post(`/stop_project_processing/`, data);

export const getProjectById = (projectId, sorting = '', skip = 0, limit = 20) => API.get(`/projects/${projectId}/?skip=${skip}&limit=${limit}${sorting ? '&order=' + sorting : ''}`);
export const getProjectFilters = (projectId) => API.get(`/projects/${projectId}/filters/`);
export const getAllProjectFilters = () => API.get(`/projects/filters/`);
export const getFilteredProject = (projectId, query, sorting = '') => {
  console.log(query)
  const q = Object.keys(query)
    .map(key => `${key}=${query[key]}`)
    .join('&');
  return API.get(`/projects/${projectId}/?${q}${sorting ? '&order=' + sorting : ''}`)
};

export const getDetailedProjectReport = (projectId, videoId, frame) => API.get(`/projects-reports/${projectId}/detailed-frame/?video_id=${videoId}&frame_id=${frame}`);
export const getProjectReport = (projectId, videoId, reportType = 'detailed') => {
  return API({
    method: 'get',
    url: `/projects-reports/${projectId}/?${videoId ? `video_id=${videoId}&` : ''}report_type=${reportType}`,
    responseType: 'arraybuffer',
  })
};
export const getProjectHeatmap = (projectId) => API.get(`/projects/${projectId}/heatmaps/`);
export const getProjectTimeline = (projectId) => API.get(`/projects/${projectId}/timelines/`);

export const downloadProjectReport = (data, filename = 'report.pdf', mime = 'application/pdf') => {
  const blob = new Blob([data], {type: mime || 'application/octet-stream'});
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename);
    return;
  }

  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  setTimeout(() => {
    window.URL.revokeObjectURL(blobURL);
  }, 100);
};

export const getProjectTypes = () => API.get(`/projects/types/`);

